import Headroom from "react-headroom"
import { AdHome } from "../features/AdHome/AdHome"
import Navbar from "../features/Navbar/Navbar"
import PriceSection from "../features/PriceSection/PriceSection"
import ProductList from "../features/Product-List/component/ProductList" 
import Footer from "../features/common/Footer"

function Home(){
return(<div>
  <Headroom> 
  <Navbar/>
  </Headroom>
  <AdHome/>
  <ProductList/>
  <PriceSection/>
  <Footer/>
</div>)
}
export default Home